import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';
import { AlertService } from 'src/app/services/alert.service';
import { DivisionService } from 'src/app/services/division.service';
import { DepartmentType } from 'src/enum/departmenttype';

@Component({
  selector: 'app-divisionlevelpopup',
  templateUrl: './divisionlevelpopup.component.html',
  styleUrls: ['./divisionlevelpopup.component.scss']
})
export class DivisionlevelDrillpopupComponent implements OnInit {
  result: any;
  statetargetlist: any[];
  mainstatetargetlist: any[];
  tableData: any;
  cardData: any;
  buttonType: string;
  subdivisionId: any;
  disableField: boolean = false;
  view: boolean;
  subDivisionId: any;
  divisionId: any;
  cardtotaltarget: any;
  samecardtotaltarget: number;
  remainingTarget: any;
  remainingTargetAmount: any;
  isshowSubsidy: boolean;
  physcialno: number;
  remainingphyscialno: number;
  subsidyAmounts: number;
  remainingTargetset: number;
  remainingTargetAmountset: number;
  physcialnoset: number;
  subsidyAmountsset: number;
  btndisabled: boolean = false;
  public Department=DepartmentType;
  departmentName: any;
  
  constructor(
    public dialogRef: MatDialogRef<DivisionlevelDrillpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedData: any,
    public addServiceDialog: MatDialog,
    private divisionService: DivisionService,
    private alertService: AlertService,
  ) {
    this.tableData = this.dataRecievedData.tableData;
    this.cardData = this.dataRecievedData.cardData;
    this.view = this.dataRecievedData?.view;
    this.isshowSubsidy = this.dataRecievedData?.isshowSubsidy;
    this.divisionId = this.dataRecievedData?.divisionId;
    this.subDivisionId = this.dataRecievedData?.subDivisionId;
    this.cardtotaltarget = this.dataRecievedData?.cardtotaltarget;
    this.remainingTarget = this.dataRecievedData?.remainingTarget,
      this.remainingTargetset = this.dataRecievedData?.remainingTarget,
      this.remainingTargetAmount = this.dataRecievedData?.remainingTargetAmount
    this.remainingTargetAmountset = this.dataRecievedData?.remainingTargetAmount
    this.departmentName=this.dataRecievedData?.departmentName
  }

  ngOnInit(): void {
    this.physcialnoset = 0;
    this.subsidyAmountsset = 0;
    this.showTable();
    if (this.cardData.type === 'State') {
      this.divisionService.division(this.tableData.financialYearId,this.tableData.departmentId ,this.tableData.dbtGoId, this.tableData.dbtSchemeId, this.tableData.dbtComponentId, this.tableData.dbtProductId, true).subscribe(result => {
        this.statetargetlist = [];
        this.statetargetlist = result;
        this.physcialno = _.sumBy(this.statetargetlist, 'totalMachinery');
        this.remainingphyscialno = _.sumBy(this.statetargetlist, 'remainingMachinery');
        this.subsidyAmounts = _.sumBy(this.statetargetlist, 'subsidyAmount');
      })
    } else {
      if (this.cardData.totalTarget === 0) {
        // this.addTable();
        this.editTable();
        this.buttonType = "Submit";
      } else {
        this.editTable();
        this.buttonType = "Update";
      }
    }
    if (this.view) {
      this.disableField = true;
    }
    if ((this.divisionId === 0 && this.cardData.type === 'SubDivision')  || (this.divisionId === 0 && this.cardData.type === "Block")|| (this.divisionId === 0 && this.cardData.type === 'Village') ||
      (this.divisionId > 0 && this.subDivisionId === 0 && this.cardData.type === 'Village')) {
      this.disableField = true;
    }
  }

  addTable() {
  //  ----- need deparmentId------>

    this.divisionService.getdbtstatetarget(this.tableData.financialYearId,1,this.tableData.dbtGoId, this.tableData.dbtSchemeId, this.tableData.dbtComponentId, true).subscribe(result => {
      this.statetargetlist = [];
      this.statetargetlist = result;
      this.physcialno = _.sumBy(this.statetargetlist, 'totalMachinery');
      this.remainingphyscialno = _.sumBy(this.statetargetlist, 'remainingMachinery');
      this.subsidyAmounts = _.sumBy(this.statetargetlist, 'subsidyAmount');
    });
  }

  editTable() {
    let data = {
      financialYearId: this.tableData.financialYearId,
      departmentId:this.tableData.departmentId,
      dbtGoId: this.tableData.dbtGoId,
      dbtSchemeId: this.tableData.dbtSchemeId,
      dbtComponentId: this.tableData.dbtComponentId,
      areaId: this.cardData.id,
      dbtProductId: this.tableData.dbtProductId,
    }
    if (this.cardData.type === 'Division' || this.cardData.type === 'District') {
      this.divisionService.editTableDivision(data, true).subscribe(result => {
        this.getResult(result);
      });
    } else if (this.cardData.type === 'SubDivision' || this.cardData.type === 'Block') {
      this.divisionService.editTableSubDivision(data, true).subscribe(result => {
        this.getResult(result);
      });
    } else if (this.cardData.type === 'Village') {
      this.divisionService.editTableVillage(data, true).subscribe(result => {
        this.getResult(result);
      });
    }
  }

  getResult(result) {
    this.statetargetlist = [];
    let array = result.dbtTargetListViewModel;
    this.mainstatetargetlist = [];
    this.mainstatetargetlist = JSON.parse(JSON.stringify(array));
    this.statetargetlist = result.dbtTargetListViewModel;
    this.physcialno = _.sumBy(this.statetargetlist, 'totalMachinery');
    this.remainingphyscialno = _.sumBy(this.statetargetlist, 'remainingMachinery');
    this.subsidyAmounts = _.sumBy(this.statetargetlist, 'subsidyAmount');
    this.physcialnoset = _.sumBy(this.statetargetlist, 'totalMachinery');
    this.subsidyAmountsset = _.sumBy(this.statetargetlist, 'subsidyAmount');
  }

  showTable() {
    this.divisionService.getdbtstatetargetmapping(true, this.tableData.financialYearId,this.tableData.departmentId, this.tableData.dbtGoId, this.tableData.dbtSchemeId, this.tableData.dbtComponentId).subscribe(res => {
      if(res){
        this.result = res;
      }
    })
  }

  onKeyChange(event: any, i: number) {

    var remainingMachinery = this.mainstatetargetlist[i].remainingMachinery;
    var previoustotalMachinery = this.mainstatetargetlist[i].totalMachinery;
    var data = 0;
    if (event.target.value == "") {
      data = 0;
    } else {
      data = parseInt(event.target.value);
    }
    this.statetargetlist[i].totalMachinery = data;
    this.statetargetlist[i].remainingMachinery = previoustotalMachinery < data ? (remainingMachinery + previoustotalMachinery) - data : remainingMachinery + (previoustotalMachinery - data);
    this.statetargetlist[i].subsidyAmount = data * this.cardData.subsidyPerUnit
    this.physcialno = _.sumBy(this.statetargetlist, 'totalMachinery');
    this.remainingphyscialno = _.sumBy(this.statetargetlist, 'remainingMachinery');
    this.subsidyAmounts = _.sumBy(this.statetargetlist, 'subsidyAmount');
    this.remainingTargetset = this.remainingTarget - (this.physcialno - this.physcialnoset);
    this.remainingTargetAmountset = this.remainingTargetAmount - (this.subsidyAmounts - this.subsidyAmountsset);
    if (this.statetargetlist[i].remainingMachinery < 0) {
      this.alertService.error(this.cardData.type + ' ' + "Target is Exeeded");
    }
  }

  submit() {
    this.btndisabled = true;
    var resultdata;
    for (var _i = 0; _i < this.statetargetlist.length; _i++) {
      if (this.statetargetlist[_i].remainingMachinery < 0) {
        this.alertService.error(this.cardData.type + ' ' + "Target is Exeeded");
        this.btndisabled = false;
        return
      }
    }
    this.samecardtotaltarget = _.sumBy(this.statetargetlist, "totalMachinery");
    if (this.tableData.totalMachinery < (this.cardtotaltarget + this.samecardtotaltarget)) {
      this.alertService.error(this.cardData.type + ' ' + "Target is Exeeded");
      this.btndisabled = false;
      return
    }

    if (this.cardData.type === 'Division' || this.cardData.type === 'District') {
      if (this.cardData.assignedTarget > this.samecardtotaltarget) {
        this.alertService.error("Total Assigned Target Limit Exceeded, Once the Target is Assigned it cannot be reverted, Until there is a Un-Utilized Target");
        this.btndisabled = false;
        return
      }
      resultdata = {
        id: 0,
        financialYearId: this.tableData.financialYearId,
        departmentId:this.tableData.departmentId,
        districtId:this.cardData.type === 'District'?this.cardData.id:null,
        dbtGoId: this.tableData.dbtGoId,
        dbtSchemeId: this.tableData.dbtSchemeId,
        dbtComponentId: this.tableData.dbtComponentId,
        dbtProductId: this.tableData.dbtProductId,
        divisionId:this.cardData.type === 'Division'?this.cardData.id:null,
        stateTargetListSaveViewModel: this.statetargetlist,
      };
      this.divisionService.savediv(resultdata, true).subscribe((result) => {
        this.submitResult(result);
      });
    } else if (this.cardData.type === 'SubDivision' || this.cardData.type === 'Block') {
      if (this.cardData.assignedTarget > this.samecardtotaltarget) {
        this.alertService.error("Total Assigned Target Limit Exceeded, Once the Target is Assigned it cannot be reverted, Until there is a Un-Utilized Target");
        this.btndisabled = false;
        return
      }
      resultdata = {
        id: 0,
        financialYearId: this.tableData.financialYearId,
        dbtGoId: this.tableData.dbtGoId,
        dbtSchemeId: this.tableData.dbtSchemeId,
        dbtComponentId: this.tableData.dbtComponentId,
        dbtProductId: this.tableData.dbtProductId,
        subDivisionId: this.cardData.id,
        departmentId:this.tableData.departmentId,
        stateTargetListSaveViewModel: this.statetargetlist,
      };
      this.divisionService.saveSubDiv(resultdata, true).subscribe((result) => {
        this.submitResult(result);
      });
    } else if (this.cardData.type === 'Village') {
      if (this.cardData.totalBookingCount > this.samecardtotaltarget) {
        this.alertService.error("Already " + this.cardData.totalBookingCount + " Farmers Booked, So it cannot be reverted");
        this.btndisabled = false;
        return
      }
      this.subdivisionId = this.dataRecievedData.subdivisionId;
      resultdata = {
        id: 0,
        financialYearId: this.tableData.financialYearId,
        dbtGoId: this.tableData.dbtGoId,
        dbtSchemeId: this.tableData.dbtSchemeId,
        dbtComponentId: this.tableData.dbtComponentId,
        dbtProductId: this.tableData.dbtProductId,
        villageId: this.cardData.id,
        subDivisionId: this.subdivisionId,
        departmentId:this.tableData.departmentId,
        stateTargetListSaveViewModel: this.statetargetlist,
      };
      this.divisionService.saveVillage(resultdata, true).subscribe((result) => {
        this.submitResult(result);
      });
    }
  }

  submitResult(result) {
    if (result && result.isSuccess) {
      if (this.cardData.totalTarget !== 0) {
        this.alertService.success(this.cardData.type + ' ' + "Target updated Successfully");
      } else {
        this.alertService.success(this.cardData.type + ' ' + "Target added Successfully");
      }
      this.dialogRef.close(true);
    } else {
      if (result && result.failures) {
        this.btndisabled = false;
        this.alertService.error(result.failures.toString());
      }
    }
  }

  cancel() {
    this.dialogRef.close(false);
  }

}
